<script>
  import Container from '@/elements/Containers/FullCentred.svelte';
import LgTextBlock from '../library/content/lg-text-block.svelte';
  
  export let contact;

  // let layout = contact.layout;
  // let pretext = contact.content.pretext;
  let context = contact.content.context;
  let subtext = contact.content.subtext;
  // let meta = contact.meta;
</script>

<style></style>

<section id="contact-us" class="py-4xl bg-gray-50">
  <Container>
    <div class="flex flex-col lg:flex-row">
      <div class="lg:w-3/5">
        <LgTextBlock data={context}></LgTextBlock>

        <div class="px-sm sy-lg">
          <div class="text-gray-900 opacity-95 px-xs sy-sm">
            {#each context.items as item}
            <div class="flex sx-xs">
              <div class="w-6 h-6">
                <span>{@html item.icon}</span>
              </div>
              <p class="p3">{item.text}</p>
            </div>
            {/each}
          </div>
          <div class="sy-xs max-w-xl">
            {#each subtext.text as text}
              <p class="p5">{text}</p>
            {/each}
          </div>
        </div>

      </div>

      <div class="flex justify-start mr-auto px-sm py-xl lg:w-2/5">
        <div class="pipedriveWebForms" data-pd-webforms="https://webforms.pipedrive.com/f/1tgiNWR3xsEJ8mYUYT2LBaK5z16GZQ3EdoerEw7UKSy5b02qRJU4ytOQpWgOyyyxt"></div>
      </div>
    </div>
  </Container>
</section>